import React from 'react';
import { Button } from '../UI';
import classes from './ProjectDetailPage.module.css';

const ProjectView = ({
  project,
  formatDate,
  onEdit,
  onDelete,
  onDownloadAll,
  deleting
}) => {
  return (
    <div className={classes.form}>
      <div className={classes.formGroup}>
        <label className={classes.label}>
          Project name <span className={classes.required}>*</span>
        </label>
        <div className={classes.readOnlyValue}>{project.name || 'N/A'}</div>
      </div>

      <div className={classes.formGroup}>
        <label className={classes.label}>
          Location <span className={classes.required}>*</span>
        </label>
        <div className={classes.readOnlyValue}>{project.location || 'N/A'}</div>
      </div>

      <div className={classes.formGroup}>
        <label className={classes.label}>Creation date</label>
        <div className={classes.readOnlyValue}>{formatDate(project.createdAt)}</div>
      </div>

      <div className={classes.formGroup}>
        <label className={classes.label}>Notes</label>
        <div className={classes.readOnlyValue}>
          {project.notes || 'No notes'}
        </div>
      </div>

      <div className={classes.formGroup}>
        <label className={classes.label}>
          Status <span className={classes.required}>*</span>
        </label>
        <div className={classes.readOnlyValue}>{project.status || 'N/A'}</div>
      </div>

      <div className={classes.formButtons}>
        <Button
          type="button"
          variant="primary"
          onClick={onEdit}
          className={classes.editButton}
        >
          Edit Project
        </Button>
        <Button
          type="button"
          variant="secondary"
          onClick={onDelete}
          disabled={deleting}
          className={classes.deleteButton}
        >
          {deleting ? 'Deleting...' : 'Delete Project'}
        </Button>
      </div>

      <Button
        type="button"
        variant="primary"
        onClick={onDownloadAll}
        className={classes.downloadAllButton}
        fullWidth
      >
        Download all certificates
      </Button>
    </div>
  );
};

export default ProjectView;

